
class StringUtils {
    constructor() {}

    static IsNullOrWhitespace(inputStr) {
        if (inputStr == null) {
            return true;
        }
        else if (typeof(inputStr) === "string") {
            const trimmedInputStr = inputStr.trim();
            return (trimmedInputStr.length < 1);
        }
        else {
            throw new TypeError("IsNullOrWhitespace: input is not null, and not a string");
        }
    }
}

export default StringUtils;



//////////////////
// WEBPACK FOOTER
// ./src/utility/StringUtils.js
// module id = JXVh
// module chunks = 1